import { render } from "./UsersDetails.vue?vue&type=template&id=52061f55&scoped=true"
import script from "./UsersDetails.vue?vue&type=script&lang=js"
export * from "./UsersDetails.vue?vue&type=script&lang=js"

import "./UsersDetails.vue?vue&type=style&index=0&id=52061f55&lang=scss"
import "./UsersDetails.vue?vue&type=style&index=1&id=52061f55&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52061f55"]])

export default __exports__